import { render, staticRenderFns } from "./authorizationRegister.vue?vue&type=template&id=0887bd4a&"
import script from "./authorizationRegister.vue?vue&type=script&lang=js&"
export * from "./authorizationRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports